import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { UilChartPie } from '@iconscout/react-unicons';
import i18n from 'i18n/i18n';
// import CustomUilChartPie from 'components/icons/CustomUilChartPie';
export interface Route {
    name: string;
    icon?: IconProp | string | string[];
    iconSet?: 'font-awesome' | 'feather' | 'unicons';
    pages?: Route[];


    path?: string;
    pathName?: string;
    flat?: boolean;
    topNavIcon?: string;
    dropdownInside?: boolean;
    active?: boolean;
    new?: boolean;
    hasNew?: boolean;
    isNext?: boolean;
}
export interface RouteItems {
    label: string;
    horizontalNavLabel?: string;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
    labelDisabled?: boolean;
    pages: Route[];
    megaMenu?: boolean;
    active?: boolean;
}

// import CustomUilChartPie from 'components/icons/CustomUilChartPie';

export const getRoutes = (): RouteItems[] => [
    {
        label: i18n.t('nav.sitemap.substations', { ns: 'translation' }),
        horizontalNavLabel: 'home',
        active: true,
        icon: UilChartPie,
        labelDisabled: true,
        pages: [
            {
                name: i18n.t('nav.sitemap.home', { ns: 'translation' }),
                icon: 'pie-chart',
                active: true,
                flat: true,
                path: '/',
                pathName: 'default-dashboard',
                topNavIcon: 'cube',
            },
            {
                name: i18n.t('nav.sitemap.inspectionRoutes', { ns: 'translation' }),
                icon: 'git-merge',
                active: true,
                flat: true,
                path: '/inspectionRoutes',
                pathName: 'inspectionRoutes',
                topNavIcon: 'cube',
            },
            {
                name: i18n.t('nav.sitemap.dataImport', { ns: 'translation' }),
                icon: 'database',
                active: true,
                flat: true,
                path: '/dataImport',
                pathName: 'dataImport',
                topNavIcon: 'cube',
            }
        ]
    }];

export const routes: RouteItems[] = getRoutes();
